<template>
    <form class="ministry-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['id']}">
            <label for="id" class="col-sm-2 control-label">Identificador</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="id" v-model="data.id">
                <div class="help-block" v-for="e in errors['id']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['glosa']}">
            <label for="glosa" class="col-sm-2 control-label">Glosa</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="glosa" v-model="data.glosa">
                <div class="help-block" v-for="e in errors['glosa']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['mensaje']}">
            <label for="mensaje" class="col-sm-2 control-label">Mensaje</label>
            <div class="col-sm-10">
                 <textarea class="form-control" id="mensaje" v-model="data.mensaje" rows="5"></textarea>
                
                <div class="help-block" v-for="e in errors['mensaje']">{{e}}</div>
            </div>
        </div>
  

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/formadepago">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    .el-select{
        display: block;
    }
</style>
<script>
    export default {
        data: function(){
            return{
                data: _.cloneDeep(this.formadepago),
                errors: {}
            }
        },
        props: ['formadepago','edit'],
        methods:{
            submit: function(){
                var self = this;

                axios({
                    url: self.edit ? 'backend/formadepago/'+self.data.id : 'backend/formadepago',
                    method: self.edit ? 'PUT' : 'POST',
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            }
        }
    }
</script>